import React from "react";
import MobileNav from "./mobileNav";
import Header from "./Header";
import Footer from "./Footer";

const Layout = ({ children }) => {
  return (
    <>
      <MobileNav />
      <Header />
      {children}
      <Footer />
    </>
  );
};

export default Layout;
